import { render, staticRenderFns } from "./usercenter.vue?vue&type=template&id=2ae60034&scoped=true"
import script from "./usercenter.vue?vue&type=script&lang=js"
export * from "./usercenter.vue?vue&type=script&lang=js"
import style0 from "./usercenter.vue?vue&type=style&index=0&id=2ae60034&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae60034",
  null
  
)

export default component.exports